import * as React from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import * as HelperSrc from "../../HelperSrc";
import { logout } from "../../actions/logout";
import { store } from "../../store";

class LogoutPage extends React.Component<RouteComponentProps> {
    componentDidMount(): void {
        logout();
    }

    public render() {
        if (!store.user.id) {
            return <Redirect to={HelperSrc.ROUTE_TYPE.LOGIN} />;
        }
        return null;
    }
}

export { LogoutPage };
